// extracted by mini-css-extract-plugin
module.exports = {"LatestBlogEntries":"LatestBlogEntries_LatestBlogEntries__VCeka","posts":"LatestBlogEntries_posts__Yb0Fn"};